<template>
    
    <v-dialog 
        v-model="display" 
        width="500" 
        persistent
    >
        <LoadingSendingMail :value="loadingMail" />
        <MessageOverlay ref="overlay"/>

            <v-card>
                <v-card-title class="text-h5">{{ $vuetify.lang.t('$vuetify.account.changeMail.mailchange') }}</v-card-title>
                <v-card-text class="pb-0">
                    <v-form ref="formEditMail" v-model="mailFormValidation" lazy-validation>
                        <v-text-field
                            v-model="newMail.value"
                            outlined
                            required
                            :disabled="displayVerificationCode"
                            :rules="newMail.rules"
                            :label="$vuetify.lang.t('$vuetify.account.changeMail.newMail')+'*'"
                        ></v-text-field>

                        <v-text-field v-if="displayVerificationCode"
                            v-model="verificationCode"
                            outlined
                            :required="displayVerificationCode"
                            :label="$vuetify.lang.t('$vuetify.account.changeMail.verificationCode')+'*'"
                        ></v-text-field>
                       
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn v-if="!displayVerificationCode"
                        :disabled="!mailFormValidation"
                        :class="{ 'gradient-wintech': (mailFormValidation) }"
                        @click="sendVerifCode"
                    >
                        <v-icon left>mdi-content-save</v-icon>
                        {{ $vuetify.lang.t('$vuetify.account.changeMail.save') }}
                    </v-btn>
                    <v-btn v-else
                        :disabled="!mailFormValidation || verificationCode===''"
                        :class="!mailFormValidation || verificationCode===''? '' : 'gradient-wintech'"
                        @click="saveMail"
                    >
                        <v-icon left>mdi-content-save</v-icon>
                        {{ $vuetify.lang.t('$vuetify.account.changeMail.save') }}
                    </v-btn>
                    <v-btn
                        color="error"
                        @click="cancelMailDialog"
                    >
                        <v-icon left>mdi-cancel</v-icon>
                        {{ $vuetify.lang.t('$vuetify.account.changeMail.cancel') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
</template>
<script>
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';
import MessageOverlay from '@/components/Overlay/MessageOverlay.vue'
import LoadingSendingMail from '@/components/Overlay/LoadingSendingMail.vue'

export default {
    name: "ChangeMail",
    components: {MessageOverlay, LoadingSendingMail},
    props: {
        display: Boolean,
    },
    data() {
        return {
            newMail: {
                value: "",
                show: false,
                focus: false,
                rules: [
                    v => !!v || this.$vuetify.lang.t('$vuetify.account.changeMail.emailisrequired') ,
                    v => /.+@.+\..+/.test(v) || this.$vuetify.lang.t('$vuetify.account.changeMail.emailmustbevalid'),
                ]
            },
            mailFormValidation: true,
            verificationCode: "",
            randomNumberToVerify: "",
            displayVerificationCode: false,
            loadingMail: false,
        };
    },

    methods: {
        ...mapActions(["SetUser"]),
        async sendVerifCode() {
            if (this.$refs.formEditMail.validate()) {
                this.loadingMail=true;
                try {
                    const res = await axios.put('users/queryChangeEmail', {email: this.newMail.value});
                    if (res.status == 200) {
                        this.randomNumberToVerify = res.data;
                        this.displayVerificationCode = true;
                    }
                } catch(error) {
                    if ('response' in error && error.response.status === 409) {
                        this.$refs.overlay.showOverlay("error", this.$vuetify.lang.t('$vuetify.account.changeMail.emailalreadyinuse'));
                    } else {
                        this.$refs.overlay.showOverlay("error", error);
                    }
                    
                }
                this.loadingMail=false;
            }
        },
        async saveMail() {
            if (this.$refs.formEditMail.validate() ) {
                if(this.randomNumberToVerify.toString() !== this.verificationCode.toString()){
                    this.$refs.overlay.showOverlay("error", this.$vuetify.lang.t('$vuetify.account.changeMail.wrongverificationcode'));
                    return;
                }
                let data = Object.assign({}, this.user);
                data.email = this.newMail.value;
                try {
                    const res = await axios.put('users/changeMail', {email: this.newMail.value, originalEmail: this.user.email, role: this.user.role});
                    if (res.status == 200) {
                        data.token = res.data.token;
                        await this.SetUser(data);
                        this.$refs.formEditMail.reset();
                        this.verificationCode= "";
                        this.randomNumberToVerify= "";
                        this.displayVerificationCode= false;
                        this.$emit("valid");
                    }
                } catch(error) {
                    this.$refs.overlay.showOverlay("error", error);
                }
            }
        },

        cancelMailDialog() {
            this.$refs.formEditMail.reset();
            this.verificationCode= "";
            this.randomNumberToVerify= "";
            this.displayVerificationCode= false;
            this.$emit("cancel");
        },
    },
    computed: {
        ...mapGetters({ user: "StateUser"}),
    }
};
</script>